(function($){

    $(window).on('load', function(){
        initContentBoxSlider();
    });
    $(window).resize(function(){
        initContentBoxSlider();
    });

    function initContentBoxSlider(){
        if(!$('.content-box__slider-container')[0]){
            return false;
        }
        setTimeout(function(){
            var swiper = new Swiper('.content-box__slider-container', {
                spaceBetween: 0,
                effect: 'fade',
                lazy: {
                    preloaderClass: 'content-box__preloader',
                },
                // autoplay: {
                //     delay: 7000,
                //     disableOnInteraction: false
                // },
                pagination: {
                    el: '.content-box__pagination',
                    clickable: true
                }
            });
        }, 0);
    }

}(jQuery));
